import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot, Router, RouterStateSnapshot
} from '@angular/router';
import { KeycloakAuthGuard, KeycloakService } from 'keycloak-angular';
import { NumberCons, RoutesCons } from '../constants/const';
import { ObservableService } from './observable.service';
import { PlatformLocation } from '@angular/common';

@Injectable({
  providedIn: 'root',
})
export class GuardService extends KeycloakAuthGuard {
  constructor(
    protected readonly router: Router,
    protected readonly keycloak: KeycloakService,
    private observableService: ObservableService,
    private platform: PlatformLocation
  ) {
    super(router, keycloak);
  }

  public async isAccessAllowed(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Promise<boolean> {
    this.observableService.updateClientDoctor(route.url[NumberCons.zero].path);
    // Force the user to log in if currently unauthenticated.
    if (!this.authenticated) {
      await this.keycloak.login({ redirectUri: `${window.location.origin}${this.platform.getBaseHrefFromDOM()}${state.url}`, });
      return false;
    }

    // Get the roles required from the route.
    const requiredRoles = route.data.roles;

    // Allow the user to to proceed if no additional roles are required to access the route.
    if (!(requiredRoles instanceof Array) || requiredRoles.length === 0) {
      return true;
    }

    // Allow the user to proceed if all the required roles are present.
    const validRole = requiredRoles.some((role: any) => this.roles.includes(role)) || state?.url === `/${RoutesCons.home}`;
    if (validRole) {
      return true;
    } else {
      this.router.navigate([RoutesCons.home]);
      return false;
    }

  }
}
